export default {
  staff: {
    id: "",
    code: "",
    prefixId: "",
    firstNameLocal: "",
    lastNameLocal: "",
    firstNameEng: "",
    lastNameEng: "",
    telephone: "",
    email: "",
    picturePath: "",
    isActive: null,
    userId: "",
  },
  staffs: [],
  staffsDdl: [],
  processing: false,
  error: null,
  success: null,
}

